/*
	CHIPSSLIDER v0.002
	Last update 1/23/2022

	0.002 - Filippo recommended using class instead of object
*/

import Flickity from "flickity";

export default class {
	constructor(options) {
		this.defaults = {};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "CHIPSSLIDER";
		this.init();
	}

	init() {
		this.bindEvents(true);
	}

	bindEvents(bindDirection) {
		this.sliderObj = [];

		if (bindDirection) {
			// Paged Wrap
			let domSliderEls = document.querySelectorAll(".paged-wrap");
			if (domSliderEls.length > 0) {
				for (var s = 0; s < domSliderEls.length; s++) {
					this.sliderObj.push(
						new Flickity(domSliderEls[s], {
							wrapAround: false,
							prevNextButtons: true,
							cellSelector: ".paged-single",
							cellAlign: "left",
							pageDots: false,
							contain: false,
						}).on("select", () => {
							// Do something with the active slide
						})
					);
				}
			}

			// Instances where carousel stuff is "fixed"
			let domSliderElsFixed = document.querySelectorAll(
				".carousel-wrap-fixed"
			);
			if (domSliderElsFixed.length > 0) {
				for (var t = 0; t < domSliderElsFixed.length; t++) {
					this.sliderObj.push(
						new Flickity(domSliderElsFixed[t], {
							wrapAround: false,
							prevNextButtons: false,
							cellSelector: ".carousel-item",
							cellAlign: "left",
							pageDots: false,
							contain: false,
						}).on("select", () => {
							// Do something with the active slide
						})
					);
				}
			}

			// Instances where carousel stuff is "centered"
			let domSliderElsCentered = document.querySelectorAll(
				".carousel-wrap-centered"
			);
			if (domSliderElsCentered.length > 0) {
				for (var t = 0; t < domSliderElsCentered.length; t++) {
					this.sliderObj.push(
						new Flickity(domSliderElsCentered[t], {
							wrapAround: false,
							prevNextButtons: false,
							cellSelector: ".carousel-item",
							cellAlign: "center",
							pageDots: false,
							contain: false,
						}).on("select", () => {
							// Do something with the active slide
						})
					);
				}
			}
		}
	}

	destroy() {
		this.bindEvents(false);
	}
}
